import type { AwsPartition } from "@p0security/integrations-aws-shared/util";

/** Where P0 writes audit files: a bucket in a customer's AWS account */
export type AuditBucket = {
  accountId: string;
  bucket: string;
  partition: AwsPartition;
  region: string;
};

// S3 general purpose bucket rules: 3-63 lowercase letters, digits, dots and
// hyphens, starting and ending with a letter or digit, no "..", not an IP
const BUCKET_NAME_PATTERN = /^[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/;
const IP_ADDRESS_PATTERN = /^\d+\.\d+\.\d+\.\d+$/;

/** Whether `name` is a valid S3 general purpose bucket name */
export const isBucketName = (name: string) =>
  BUCKET_NAME_PATTERN.test(name) &&
  !IP_ADDRESS_PATTERN.test(name) &&
  !name.includes("..");

export const BUCKET_NAME_VALIDATION_ERROR_MSG =
  "Bucket name should be 3 to 63 lowercase letters, numbers, dots or hyphens, starting and ending with a letter or number";

const REGION_PATTERN = /^[a-z]{2}(-gov)?-[a-z]+-\d+$/;

/** Whether `region` looks like an AWS region code, e.g. `us-west-2` */
export const isAwsRegion = (region: string) =>
  REGION_PATTERN.test(region.trim());

export const REGION_VALIDATION_ERROR_MSG =
  "Region should be an AWS region code, e.g. `us-west-2`";

/** The ARN of a bucket; S3 bucket ARNs carry no region or account */
export const bucketArn = (partition: AwsPartition, bucket: string) =>
  `arn:${partition}:s3:::${bucket}`;
